export enum EventTriggerEnum {
    TELEPHONE = 'TELEPHONE',
    EMAIL = 'EMAIL',
    SHARE = 'SHARE'
}